/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataView } from './dataView';
import { TableViewParameters } from './tableViewParameters';
import { AnalyticsFolder } from './analyticsFolder';


export interface AnalyticsQueryResponse { 
    folders?: Array<AnalyticsFolder>;
    list?: Array<DataView>;
    total_entries?: number;
    total_folders?: number;
    view?: TableViewParameters;
}

